import React, { useState } from 'react';
import {
    UncontrolledDropdown,
    DropdownMenu,
    DropdownToggle,
    Col,
    Label,
    Row,
} from "reactstrap";
import DatePicker from "react-datepicker";
import Head from '../../layout/head/Head';
import Content from '../../layout/content/Content';
import {
    Block,
    BlockDes,
    BlockHeadContent,
    BlockTitle,
    BlockBetween,
    BlockHead,
    Icon,
    DataTableBody,
    DataTableHead,
    DataTableRow,
    DataTableItem,
    PaginationComponent,
    Button,
    DataTable,
} from '../../components/Component';
import { useSubmissions } from '../../api/reports/hooks';

const SubmissionsPage = () => {
    const [sm, setSm] = useState(false);
    const [params, setParams] = useState({
        utm_source: '',
        utm_medium: '',
        utm_campaign: '',
        utm_term: '',
        utm_content: '',
        startDate: '',
        endDate: '',
        page: 1,
        limit: 10,
        sortBy: 'submission_time',
        order: 'desc',
    });

    const { data: submissions, isLoading } = useSubmissions({ params });


    const resetFilters = () => {
        setParams({
            utm_source: '',
            utm_medium: '',
            utm_campaign: '',
            utm_term: '',
            utm_content: '',
            startDate: '',
            endDate: '',
            page: 1,
            limit: 10,
            sortBy: 'submission_time',
            order: 'desc',
        });
    };

    return (
        <React.Fragment>
            <Head title="Campaign Submissions" />
            <Content>
                <BlockHead size="sm">
                    <BlockBetween>
                        <BlockHeadContent>
                            <BlockTitle tag="h3" page>
                                Campaign Submissions
                            </BlockTitle>
                            <BlockDes className="text-soft">
                                <p>Total {submissions?.totalDocs} submissions</p>
                            </BlockDes>
                        </BlockHeadContent>
                        <BlockHeadContent>
                            <div className="toggle-wrap nk-block-tools-toggle">
                                <a
                                    href="#more"
                                    className="btn btn-icon btn-trigger toggle-expand me-n1"
                                    onClick={(ev) => {
                                        ev.preventDefault();
                                        setSm(!sm);
                                    }}
                                >
                                    <Icon name="more-v" />
                                </a>
                                <div className="toggle-expand-content" style={{ display: sm ? 'block' : 'none' }}>
                                    <ul className="nk-block-tools g-3">
                                        <li>
                                            <a href="#" className="btn btn-white btn-dim btn-outline-light">
                                                <Icon name="download-cloud"></Icon>
                                                <span>Export</span>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </BlockHeadContent>
                    </BlockBetween>
                </BlockHead>

                <Block>
                    <DataTable className="card-stretch">
                        <div className="card-inner-group">
                            <div className="card-inner position-relative card-tools-toggle">
                                <div className="card-title-group">
                                    <div className="card-tools">
                                        {/* Future: Bulk actions */}
                                    </div>
                                    <div className="card-tools me-n1">
                                        <ul className="btn-toolbar">
                                            <li>
                                                <Button
                                                    onClick={resetFilters}
                                                    className="btn-icon search-toggle toggle-search"
                                                >
                                                    <Icon name="undo"></Icon>
                                                </Button>
                                            </li>
                                            <li className="btn-toolbar-sep"></li>
                                            <li>
                                                <UncontrolledDropdown>
                                                    <DropdownToggle
                                                        tag="a"
                                                        className="btn btn-trigger btn-icon dropdown-toggle"
                                                    >
                                                        <div className="dot dot-primary"></div>
                                                        <Icon name="filter-alt"></Icon>
                                                    </DropdownToggle>
                                                    <DropdownMenu right className="filter-wg dropdown-menu-xl" style={{ overflow: 'visible' }}>
                                                        <div className="dropdown-head">
                                                            <span className="sub-title dropdown-title">
                                                                Filter Submissions
                                                            </span>
                                                            <div className="dropdown">
                                                                <Button
                                                                    size="sm"
                                                                    className="btn-icon"
                                                                    onClick={resetFilters}
                                                                >
                                                                    <Icon name="undo"></Icon>
                                                                </Button>
                                                            </div>
                                                        </div>
                                                        <div className="dropdown-body dropdown-body-rg">
                                                            <Row className="gx-6 gy-3">
                                                                <Col sm="6">
                                                                    <div className="form-group">
                                                                        <Label className="overline-title overline-title-alt">UTM Source</Label>
                                                                        <input
                                                                            type="text"
                                                                            className="form-control"
                                                                            placeholder="UTM Source"
                                                                            value={params.utm_source}
                                                                            onChange={(e) => setParams({ ...params, page: 1, utm_source: e.target.value })}
                                                                        />
                                                                    </div>
                                                                </Col>
                                                                <Col sm="6">
                                                                    <div className="form-group">
                                                                        <Label className="overline-title overline-title-alt">UTM Medium</Label>
                                                                        <input
                                                                            type="text"
                                                                            className="form-control"
                                                                            placeholder="UTM Medium"
                                                                            value={params.utm_medium}
                                                                            onChange={(e) => setParams({ ...params, page: 1, utm_medium: e.target.value })}
                                                                        />
                                                                    </div>
                                                                </Col>
                                                                <Col sm="6">
                                                                    <div className="form-group">
                                                                        <Label className="overline-title overline-title-alt">UTM Campaign</Label>
                                                                        <input
                                                                            type="text"
                                                                            className="form-control"
                                                                            placeholder="UTM Campaign"
                                                                            value={params.utm_campaign}
                                                                            onChange={(e) => setParams({ ...params, page: 1, utm_campaign: e.target.value })}
                                                                        />
                                                                    </div>
                                                                </Col>
                                                                <Col sm="6">
                                                                    <div className="form-group">
                                                                        <Label className="overline-title overline-title-alt">UTM Term</Label>
                                                                        <input
                                                                            type="text"
                                                                            className="form-control"
                                                                            placeholder="UTM Term"
                                                                            value={params.utm_term}
                                                                            onChange={(e) => setParams({ ...params, page: 1, utm_term: e.target.value })}
                                                                        />
                                                                    </div>
                                                                </Col>
                                                                <Col sm="12">
                                                                    <div className="form-group">
                                                                        <Label className="overline-title overline-title-alt">UTM Content</Label>
                                                                        <input
                                                                            type="text"
                                                                            className="form-control"
                                                                            placeholder="UTM Content"
                                                                            value={params.utm_content}
                                                                            onChange={(e) => setParams({ ...params, page: 1, utm_content: e.target.value })}
                                                                        />
                                                                    </div>
                                                                </Col>
                                                            </Row>
                                                            <Row className="gx-6 gy-3 mt-2">
                                                                <Col sm="6">
                                                                    <div className="form-group">
                                                                        <Label className="overline-title overline-title-alt">From Date</Label>
                                                                        <div className="form-control-wrap">
                                                                            <DatePicker
                                                                                selected={params.startDate ? new Date(params.startDate) : null}
                                                                                onChange={(date) => setParams({ ...params, page: 1, startDate: date ? date.toISOString().split('T')[0] : '' })}
                                                                                className="form-control"
                                                                                placeholderText="From Date"
                                                                                dateFormat="dd/MM/yyyy"
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </Col>
                                                                <Col sm="6">
                                                                    <div className="form-group">
                                                                        <Label className="overline-title overline-title-alt">To Date</Label>
                                                                        <div className="form-control-wrap">
                                                                            <DatePicker
                                                                                selected={params.endDate ? new Date(params.endDate) : null}
                                                                                onChange={(date) => setParams({ ...params, page: 1, endDate: date ? date.toISOString().split('T')[0] : '' })}
                                                                                className="form-control"
                                                                                placeholderText="To Date"
                                                                                dateFormat="dd/MM/yyyy"
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </Col>
                                                            </Row>
                                                        </div>
                                                        <div className="dropdown-foot d-flex justify-content-center">
                                                            <Button color="primary" onClick={resetFilters}>
                                                                Clear All Filters
                                                            </Button>
                                                        </div>
                                                    </DropdownMenu>
                                                </UncontrolledDropdown>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <DataTableBody>
                                <DataTableHead>
                                    <DataTableRow>
                                        <span className="sub-text">Contact Details</span>
                                    </DataTableRow>
                                    <DataTableRow size="lg">
                                        <span className="sub-text">Lead Info</span>
                                    </DataTableRow>
                                    <DataTableRow size="lg">
                                        <span className="sub-text">UTM Parameters</span>
                                    </DataTableRow>
                                    <DataTableRow size="md">
                                        <span className="sub-text">Submission Time</span>
                                    </DataTableRow>
                                </DataTableHead>
                                {submissions?.docs?.map((item) => (
                                    <DataTableItem key={item._id}>
                                        <DataTableRow>
                                            <div className="user-card">
                                                <div className="user-info">
                                                    <span className="tb-lead">{item.fullname} <span className="dot dot-success d-md-none ms-1"></span></span>
                                                    <span>{item.contact.full_name}</span>
                                                    <span>{item.phone}</span>
                                                </div>
                                            </div>
                                        </DataTableRow>
                                        <DataTableRow size="lg">
                                            <span>{item.contact.first_name}</span>
                                            <span>{item.leadSource}</span>
                                        </DataTableRow>
                                        <DataTableRow size="lg">
                                            <span>{item.utm_source}</span>
                                            <span>{item.utm_medium}</span>
                                            <span>{item.utm_campaign}</span>
                                            <span>{item.utm_term}</span>
                                            <span>{item.utm_content}</span>
                                        </DataTableRow>
                                        <DataTableRow size="md">
                                            <span>{new Date(item.submission_time).toLocaleString()}</span>
                                        </DataTableRow>
                                    </DataTableItem>
                                ))}
                            </DataTableBody>
                            <div className="card-inner">
                                {submissions?.docs?.length > 0 ? (
                                    <PaginationComponent
                                        itemPerPage={params.limit}
                                        totalItems={submissions.totalDocs}
                                        paginate={(page) => setParams({ ...params, page })}
                                        currentPage={params.page}
                                    />
                                ) : (
                                    <div className="text-center">
                                        <span className="text-silent">No submissions found</span>
                                    </div>
                                )}
                            </div>
                        </div>
                    </DataTable>
                </Block>
            </Content>
        </React.Fragment>
    );
};

export default SubmissionsPage;